<template>
    <RouterLink :to="to">
        <div class="d-flex arrow">
            <!--<svg style="min-width: 20px;" class="icon icon-xs align-top mt-1 icon-primary">-->
                <use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-chevron-right"'></use>
            <!--</svg>-->
            <span>
                {{ text }}
            </span>
        </div>
    </RouterLink>
</template>

<script>

export default {
    name: 'ArticleNode',
    props: {
        to : {
            type: String,
            required: true
        },
        text : {
            type: String,
            required: true
        }
    }
}
</script>

<style>
.content-node-item .arrow {
  display: flex;
  align-items: flex-start;
  height: auto !important;
}
.content-node-item .arrow svg {
  flex-shrink: 0;
  margin-right: 0.25rem;
  height: auto;
}
.content-node-item span {
  line-height: 1.2;
}
.content-node-item {
  margin-bottom: 0.5rem; /* spazio tra nodi */
}
</style>